module.exports = __webpack_public_path__ + "static/media/cours.5426374c.webp";